import classNames from 'classnames';
import { ScommesseEsitoTipoBox } from 'components/scommesseEsitoTipoBox';
import { selectIsVisualizzazioneEstesa } from 'features/settings/selectors';
import { useEsitoListSorted, useInfoAggiuntivaDataByScommessaKey, useIsAvvenimento } from 'features/sport/hooks';
import { useIsAvvenimento as useIsAvvenimentoVirtual } from 'features/virtual/hooks';
import useWindowSize from 'hooks/useWindowSize';
import { useTypedSelector } from 'lib/centralStore';
import { memo } from 'react';
import { ScommesseTipoProps } from '../types';
import styles from './ScommesseTipoEsitiUnderThree.module.scss';

export const Scommessa = memo(
  function Scommessa({ scommessaKey, gtagAction }: ScommesseTipoProps) {
    const infoAggData = useInfoAggiuntivaDataByScommessaKey(scommessaKey);
    const { infoAggiuntivaKey } = infoAggData ?? {};
    const sortedEsitoKeyList = useEsitoListSorted(infoAggiuntivaKey);
    const { isMobile } = useWindowSize();
    const isAvvenimento = useIsAvvenimento();
    const isAvvenimentoVirtual = useIsAvvenimentoVirtual();
    const wEstesa = useTypedSelector(selectIsVisualizzazioneEstesa);

    return (
      <>
        {sortedEsitoKeyList.map((esitoKey) => (
          <ScommesseEsitoTipoBox
            showHeader={isMobile || isAvvenimento || isAvvenimentoVirtual || wEstesa}
            key={esitoKey}
            keyEsito={esitoKey}
            scommessaKey={scommessaKey}
            infoAggiuntivaKey={infoAggiuntivaKey}
            gtagAction={gtagAction}
            className={classNames({ [styles.containerAvvenimento]: isAvvenimento })}
            classNameButton={classNames({ [styles.boxAvvenimento]: isAvvenimento })}
          />
        ))}
      </>
    );
  },
  (prevParams, nextParams) =>
    prevParams.scommessaKey === nextParams.scommessaKey && prevParams.infoAggiuntivaKey === nextParams.infoAggiuntivaKey
);
